import { RoomModel } from "@app/catalog";

export class RoomUpdatedMessage {
    public room: RoomModel;
    
    constructor(room: RoomModel)
    {
        this.room = room;
    }
}